import { Injectable } from '@angular/core';
import { Category } from '@core/models-v2/article-detail/product-detail.interface';
import { MenuItem } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class BreadcrumbService {
  readonly HOME_ITEM: MenuItem = {
    label: 'Inicio',
    routerLink: '/',
  };
  readonly BASE_PATH = '/inicio/productos/todos/categoria';

  getFormattedBreadcrumbs(categories: Category[]): MenuItem[] {
    const breadcrumbs: MenuItem[] = [this.HOME_ITEM];
    let currentPath = this.BASE_PATH;
    const categoriesBreadcrumbs = categories.map((category) => {
      currentPath += `/${category.slug}`;
      return {
        label: category.name,
        routerLink: currentPath,
      };
    });
    breadcrumbs.push(...categoriesBreadcrumbs);
    return breadcrumbs;
  }
}
